/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function () {
	/** Instafeed */
	if ($('#instafeed').length) {
		var feed = new Instafeed({
			accessToken: InstagramToken,
			template:
				'<div class="new-instagram__photo-wrap"><div class="new-instagram__photo" style="background-image: url({{ image }})"><svg class="Icon Icon--instagram new-instagram__icon" role="presentation" viewBox="0 0 32 32"><path d="M15.994 2.886c4.273 0 4.775.019 6.464.095 1.562.07 2.406.33 2.971.552.749.292 1.283.635 1.841 1.194s.908 1.092 1.194 1.841c.216.565.483 1.41.552 2.971.076 1.689.095 2.19.095 6.464s-.019 4.775-.095 6.464c-.07 1.562-.33 2.406-.552 2.971-.292.749-.635 1.283-1.194 1.841s-1.092.908-1.841 1.194c-.565.216-1.41.483-2.971.552-1.689.076-2.19.095-6.464.095s-4.775-.019-6.464-.095c-1.562-.07-2.406-.33-2.971-.552-.749-.292-1.283-.635-1.841-1.194s-.908-1.092-1.194-1.841c-.216-.565-.483-1.41-.552-2.971-.076-1.689-.095-2.19-.095-6.464s.019-4.775.095-6.464c.07-1.562.33-2.406.552-2.971.292-.749.635-1.283 1.194-1.841s1.092-.908 1.841-1.194c.565-.216 1.41-.483 2.971-.552 1.689-.083 2.19-.095 6.464-.095zm0-2.883c-4.343 0-4.889.019-6.597.095-1.702.076-2.864.349-3.879.743-1.054.406-1.943.959-2.832 1.848S1.251 4.473.838 5.521C.444 6.537.171 7.699.095 9.407.019 11.109 0 11.655 0 15.997s.019 4.889.095 6.597c.076 1.702.349 2.864.743 3.886.406 1.054.959 1.943 1.848 2.832s1.784 1.435 2.832 1.848c1.016.394 2.178.667 3.886.743s2.248.095 6.597.095 4.889-.019 6.597-.095c1.702-.076 2.864-.349 3.886-.743 1.054-.406 1.943-.959 2.832-1.848s1.435-1.784 1.848-2.832c.394-1.016.667-2.178.743-3.886s.095-2.248.095-6.597-.019-4.889-.095-6.597c-.076-1.702-.349-2.864-.743-3.886-.406-1.054-.959-1.943-1.848-2.832S27.532 1.247 26.484.834C25.468.44 24.306.167 22.598.091c-1.714-.07-2.26-.089-6.603-.089zm0 7.778c-4.533 0-8.216 3.676-8.216 8.216s3.683 8.216 8.216 8.216 8.216-3.683 8.216-8.216-3.683-8.216-8.216-8.216zm0 13.549c-2.946 0-5.333-2.387-5.333-5.333s2.387-5.333 5.333-5.333 5.333 2.387 5.333 5.333-2.387 5.333-5.333 5.333zM26.451 7.457c0 1.059-.858 1.917-1.917 1.917s-1.917-.858-1.917-1.917c0-1.059.858-1.917 1.917-1.917s1.917.858 1.917 1.917z"></path></svg><div class="new-instagram__overlay"></div><a href="{{ link }}" target="_blank" class="new-instagram__link"></a></div></div>',
			limit: 12,
		});
		feed.run();
	}

	$('.builder-slider__slider').slick({
		infinte: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	/**
	 * Criteo Basket Tracking Tag Implementation
	 *
	 * This code monitors the open state of the cart popout via an infinite loop
	 * running every 1000 milliseconds. When the cart is detected as open, it
	 * gets the latest contents of the cart via an API request and submits this
	 * data to Criteo via their tracking script.
	 */
	// Select Cart popout DOM ele
	var $cart = $('#sidebar-cart');

	// Set interval speed to 1000 milliseconds
	var ddCartIntvalSpeed = 1000;

	// Default cart running flag to true
	var ddCartCheckRunning = true;

	// Set default cart open state to false§
	var ddCartOpen = false;

	// Set flag to determine whether the tracking script has been triggered
	// to false
	var ddCriteoFired = false;

	// Create interval looping function
	setInterval(function () {
		// Obtain state of cart - e.g open or closed
		var ddCartClosed = $cart.attr('aria-hidden');

		// If the cart is open
		if (ddCartClosed !== 'true') {
			// And we haven't yet fired the criteo tracking script
			if (!ddCriteoFired) {
				// Check we have access to global GE vars
				if (typeof GEPROXY !== 'undefined' && typeof GEP !== 'undefined') {
					// Run an AJAX query to obtain contents of cart from Shopify API
					$.ajax({
						url: '/cart.js',
						dataType: 'json',
						method: 'GET',
						success: function (resp) {
							// Upon successful return of API call

							// Create blank items array
							var items = [];

							// Check if the cart contains any items
							if (resp.items) {
								// Loop over the items in the cart
								for (var i = 0; i < resp.items.length; i++) {
									// Select the current item in the loop
									var item = resp.items[i];

									var product_price_base = item.price / 100;

									var product_quantity = item.quantity;

									// Push the required item data to the items array for
									// sending to the Criteo tracking script
									items.push({
										id: item.id,
										price: GEPROXY.ConvertPrice(
											product_price_base,
											GEP.geFactor,
											GEP.vatRateTypes,
											GEP.vatRateTypes.LocalVATRateType,
											true,
											GEP.currencyDecimalPlaces,
											product_quantity,
											false,
											null,
											GEP.priceCoefficientRate,
											null
										),
										quantity: item.quantity,
									});
								}
							}

							// Trigger the Criteo basket tag tracking functionality
							window.criteo_q.push(
								{ event: 'setAccount', account: window.theme.criteo.id }, // You should never update this line
								{ event: 'setEmail', email: window.theme.customer.email || '' }, // Can be an empty string
								{ event: 'setSiteType', type: window.deviceType },
								{ event: 'viewBasket', item: items }
							);
						},
					});
				}
			}

			// Set the Criteo fired flag to true
			ddCriteoFired = true;
		} else {
			// Set the criteo fired flag to false
			ddCriteoFired = false;
		}
	}, ddCartIntvalSpeed);

	/******************************/
	/* Cookie Manager ----- START */
	/******************************/

	$('.cookie-manager__small-button.close').on('click', function () {
		window.__rmcp = [];
		Cookies.set('adpt_closedCookiesNotif', 'true');
		Cookies.set('adpt_cookiePreferences', window.__rmcp);
		$('.cookie-manager__small, .cookie-manager__main').remove();
	});

	if (Cookies.get('adpt_cookiePreferences')) {
		window.__rmcp = JSON.parse(Cookies.get('adpt_cookiePreferences'));
	}

	if (
		!Cookies.get('adpt_closedCookiesNotif') ||
		Cookies.get('adpt_closedCookiesNotif') !== 'true'
	) {
		$('.cookie-manager__small').show();
		$('body').addClass('has-cookie-bar');
	}

	$('.cookie-manager__small-button.accept').click(function () {
		var cookieChoices = [];
		window.__rmcp = [];
		Cookies.set('adpt_closedCookiesNotif', 'true');

		$('.cookie-manager__option-slider.ticked').each(function () {
			cookieChoices.push(parseInt($(this).attr('data-cookie')));
		});

		if (cookieChoices.length !== 0) {
			Cookies.set('adpt_cookiePreferences', cookieChoices);
			window.__rmcp = cookieChoices;
		}

		$('.cookie-manager__small, .cookie-manager__main').remove();
		$('body').removeClass('scroll-lock has-cookie-bar');
		$('#gorgias-chat-container iframe#chat-button').css('bottom', '10px');
	});

	$(
		'.cookie-manager__small-button.preferences, .cookie-manager__small-button.back'
	).on('click', function () {
		$('.cookie-manager__main').toggleClass('hidden');
		$('body').toggleClass('scroll-lock');
	});

	$('.cookie-manager__option-slider').on('click', function () {
		$(this)
			.closest('.cookie-manager__option')
			.find('.cookie-manager__option-slider')
			.toggleClass('ticked');
	});

	/******************************/
	/*  Cookie Manager ----- END  */
	/******************************/

	/******************************/
	/*  Icons Carousel --- START  */
	/******************************/

	var $icons = $('.icons__carousel');

	if ($icons.length) {
		$icons.slick({
			infinte: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			prevArrow: $('.icons__arrow--prev'),
			nextArrow: $('.icons__arrow--next'),
			responsive: [
				{
					breakpoint: 720,
					settings: {
						slidesToShow: 4,
						autoplay: true,
						autoplaySpeed: 2000,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 3,
						autoplay: true,
						autoplaySpeed: 2000,
					},
				},
				{
					breakpoint: 475,
					settings: {
						slidesToShow: 2,
						autoplay: true,
						autoplaySpeed: 2000,
					},
				},
			],
		});
	}

	/******************************/
	/*  Icons Carousel ----- END  */
	/******************************/

	/**
	 * Custom workaround solution to improve swipability of carousel on
	 * product detail page.
	 *
	 * @return {null}
	 */
	(function () {
		var mobileProductCarousel = document.querySelector('.Product__Slideshow');

		if (mobileProductCarousel === null) {
			return;
		}

		var touchingCarousel = false,
			touchStartCoords;

		mobileProductCarousel.addEventListener('touchstart', function (e) {
			if (e.target.closest('.Carousel__Cell')) {
				touchingCarousel = true;
			} else {
				touchingCarousel = false;
				return;
			}

			touchStartCoords = {
				x: e.touches[0].pageX,
				y: e.touches[0].pageY,
			};
		});

		mobileProductCarousel.addEventListener(
			'touchmove',
			function (e) {
				if (!(touchingCarousel && e.cancelable)) {
					return;
				}

				var moveVector = {
					x: e.touches[0].pageX - touchStartCoords.x,
					y: e.touches[0].pageY - touchStartCoords.y,
				};

				if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) {
					e.preventDefault();
				}
			},
			{ passive: false }
		);

		// Polyfill for Element.closest
		// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.msMatchesSelector ||
				Element.prototype.webkitMatchesSelector;
		}

		if (!Element.prototype.closest) {
			Element.prototype.closest = function (s) {
				var el = this;

				do {
					if (el.matches(s)) {
						return el;
					}

					el = el.parentElement || el.parentNode;
				} while (el !== null && el.nodeType === 1);

				return null;
			};
		}
	})();

	/******************************/
	/*  VARIANT CHANGE --- START  */
	/******************************/
	$('[data-section-id="product-template"]').on('variant:changed', function (e) {
		var variant = e.originalEvent.detail.variant;
		var productJSON = JSON.parse($('[data-product-json]').html());

		if (productJSON && variant && !variant.available) {
			var productName = productJSON.product.title,
				productHandle = productJSON.product.handle,
				productID = productJSON.product.id,
				selectedSize = variant.title,
				selectedVariantID = variant.id;

			fbq('trackCustom', 'sizeOutOfStock', {
				productName: productName,
				productHandle: productHandle,
				productID: productID,
				selectedSize: selectedSize,
				selectedVariantID: selectedVariantID,
				selectedVariantURL:
					'https://' +
					Shopify.shop +
					'/products/' +
					productHandle +
					'?variant=' +
					selectedVariantID,
			});
		}
	});
	/******************************/
	/*  VARIANT CHANGE ----- END  */
	/******************************/

	/**********************************/
	/*  UTM PARAMS CAPTURE --- START  */
	/**********************************/
	var urlParams = getAllUrlParams();
	var urlKeys = Object.keys(urlParams);
	var UTMParams = {};
	var UTMCookieName = 'DDUTMParams';
	var UTMCookie =
		typeof Cookies.get(UTMCookieName) !== 'undefined'
			? JSON.parse(Cookies.get(UTMCookieName))
			: {};
	var UTMCookieKeys = Object.keys(UTMCookie);

	for (var i = 0; i < urlKeys.length; i++) {
		var key = urlKeys[i];

		if (isUTMParam(key)) {
			UTMParams[key] = urlParams[key];
		}
	}

	if (UTMCookieKeys.length === 0) {
		Cookies.set(UTMCookieName, JSON.stringify(UTMParams));
	}
	/**********************************/
	/*  UTM PARAMS CAPTURE --- END    */
	/**********************************/

	/***********************************/
	/*  ADD CART ATTRIBUTES --- START  */
	/***********************************/
	// If we're on the product page
	if ($('body').hasClass('template-product')) {
		if (UTMCookieKeys.length > 0) {
			var $cartForm = $('form[action$="/cart/add"]');

			if ($cartForm.length > 0) {
				for (var i = 0; i < UTMCookieKeys.length; i++) {
					var UTM = {
						key: UTMCookieKeys[i],
						val: decodeURI(UTMCookie[UTMCookieKeys[i]]),
					};

					$cartForm.append(
						'<input type="hidden" name="attributes[' +
							UTM.key +
							']" value="' +
							UTM.val +
							'" />'
					);
				}
			}
		}
	}
	/***********************************/
	/*  ADD CART ATTRIBUTES --- END    */
	/***********************************/

	/*************************************/
	/*  COMPLIMENTARY PRODUCT --- START  */
	/*************************************/
	var complimentaryProductHandle = window.theme.complimentaryProduct;

	if (complimentaryProductHandle) {
		var addComplimentaryProductToCart = function (productVariant) {
			$.ajax({
				url: '/cart/add.js',
				data: {
					quantity: 1,
					id: productVariant.id,
				},
				method: 'POST',
				dataType: 'json',
				success: function (res) {
					console.log(res);
				},
			});
		};

		var complimentaryProductFound = function (res) {
			var complimentaryProductVariant = res.variants[0];

			$.ajax({
				url: '/cart.js',
				method: 'GET',
				dataType: 'json',
				success: function (res) {
					var cartItems = res.items;

					if (cartItems.length) {
						var complimentaryItemExists = false;

						for (var i = 0; i < cartItems.length; i += 1) {
							var cartItem = cartItems[i];

							if (cartItem.variant_id === complimentaryProductVariant.id) {
								complimentaryItemExists = true;
								break;
							}
						}

						if (!complimentaryItemExists) {
							addComplimentaryProductToCart(complimentaryProductVariant);
						}
					}
				},
			});
		};

		var handleComplimentaryProduct = function () {
			$.ajax({
				url: '/products/' + complimentaryProductHandle + '.js',
				method: 'GET',
				dataType: 'json',
				success: complimentaryProductFound,
			});
		};

		document.addEventListener('product:added', handleComplimentaryProduct);
	}
	/*************************************/
	/*  COMPLIMENTARY PRODUCT --- END    */
	/*************************************/
});

function canSubmitCart(emailValue) {
  // Check if field has value && if value is valid email address
  if (emailValue && isValidEmail(emailValue)) {
    return true;
  }

  return false;
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function getAllUrlParams(url) {
	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

	// we'll store the parameters here
	var obj = {};

	// if query string exists
	if (queryString) {
		// stuff after # is not part of query string, so get rid of it
		queryString = queryString.split('#')[0];

		// split our query string into its component parts
		var arr = queryString.split('&');

		for (var i = 0; i < arr.length; i++) {
			// separate the keys and the values
			var a = arr[i].split('=');

			// set parameter name and value (use 'true' if empty)
			var paramName = a[0];
			var paramValue = typeof a[1] === 'undefined' ? true : a[1];

			// (optional) keep case consistent
			paramName = paramName.toLowerCase();
			if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

			// if the paramName ends with square brackets, e.g. colors[] or colors[2]
			if (paramName.match(/\[(\d+)?\]$/)) {
				// create key if it doesn't exist
				var key = paramName.replace(/\[(\d+)?\]/, '');
				if (!obj[key]) obj[key] = [];

				// if it's an indexed array e.g. colors[2]
				if (paramName.match(/\[\d+\]$/)) {
					// get the index value and add the entry at the appropriate position
					var index = /\[(\d+)\]/.exec(paramName)[1];
					obj[key][index] = paramValue;
				} else {
					// otherwise add the value to the end of the array
					obj[key].push(paramValue);
				}
			} else {
				// we're dealing with a string
				if (!obj[paramName]) {
					// if it doesn't exist, create property
					obj[paramName] = paramValue;
				} else if (obj[paramName] && typeof obj[paramName] === 'string') {
					// if property does exist and it's a string, convert it to an array
					obj[paramName] = [obj[paramName]];
					obj[paramName].push(paramValue);
				} else {
					// otherwise add the property
					obj[paramName].push(paramValue);
				}
			}
		}
	}

	return obj;
}

function isUTMParam(key) {
	if (key.indexOf('utm_') !== -1) {
		return true;
	}

	return false;
}
